export default __webpack_public_path__ + "static/media/toggleOn_blue.84a524b7.svg";